import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import DeleteAccount from "./pages/DeleteAccount"; // ✅ new import
import PrivacyPolicy from "./pages/PrivacyPolicy";
function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/delete-account" element={<DeleteAccount />} /> {/* ✅ new route */}
         <Route path="/privacy-policy" element={<PrivacyPolicy />} /> {/* ✅ new */}
      </Routes>
      <Footer />
    </>
  );
}

export default App;